import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { emailValidator, mustMatch } from "../../shared/utils/app-validators";

import { environment } from "../../../../../src/environments/environment";
import { AuthservicesService } from 'src/app/services/authservices.service';
import { JwtHelperService } from "@auth0/angular-jwt";

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  error: string;
  id
  loading = false;
  errorMessage
  emailMessage
  passwordMessage
  matchPassword
  fieldTextType = false;
  constructor(public router: Router, public fb: FormBuilder, private authenticationService: AuthservicesService) { }

  ngOnInit(): void {
    this.errorMessage = environment.errorMessage;
    this.emailMessage = environment.emailMessage;
    this.passwordMessage = environment.passwordMessage
    this.matchPassword = environment.matchPassword
    this.form = this.fb.group(
      {
        email: [null, [Validators.required, Validators.email]],
        password: [null, [Validators.required, Validators.minLength(6)]],
        confirmPassword: [null, Validators.required],
      },
      {
        validator: mustMatch('password', 'confirmPassword')
      }
    );
  }

  get f() { return this.form.controls; }


  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.form.valid) {
      let email = this.form.get('email').value
      let password = this.form.get('password').value
      let deviceType = "web";
      let version = "1";
      let role = "Community";
      let obj = { email: email, password: password, deviceType: deviceType, version: version, role: role }
      this.authenticationService.signUp(obj).subscribe(
        data => {
          let user = data;
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(user.token);
          console.log(decodedToken, 'decodedToken')

          let info = { email: this.form.get('email').value, name: '' }
          localStorage.setItem('userobj', JSON.stringify(decodedToken));

          localStorage.setItem('user', JSON.stringify(info));
          localStorage.setItem('email', this.form.get('email').value)
          this.router.navigate(["/email-verification"], { queryParams: {signUp: true} });
          this.authenticationService.successMessage(environment.verificationMessage, 'success')
        },
        error => {
          console.log(error.error, 'testing')
          if (error) {
            if(error.error.error == "email_exists_error"){
             return this.authenticationService.successMessage('This email is already registered. Please Login', 'error')
            }
            else if(error.error.message) {
              this.authenticationService.successMessage(error.error.message, 'error')
            }

          }
        }
      );
    }
  }
  onReset() {
    this.submitted = false;
    this.form.reset();
  }
}




